export default function copyText(text, callback?: (textCopied: boolean, error?: any) => void) {
    if (!navigator.clipboard) {
        const textarea = document.createElement('textarea');

        textarea.value = text;

        document.body.appendChild(textarea);

        textarea.select();

        try {
            document.execCommand('copy');
            callback?.(true);
            console.log('Text copied to clipboard');
        } catch (err) {
            console.error('Unable to copy text', err);
            callback?.(false);
        }

        document.body.removeChild(textarea);

        return;
    }

    // Using Clipboard API where available
    navigator.clipboard.writeText(text).then(() => {
        console.log('Text copied to clipboard');
        callback?.(true);
    }).catch(err => {
        callback?.(false, err);
    });
}

